import * as R from 'ramda';
import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterProduct extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    const groupedProducts = R.groupBy((product) => product.code || '', orderProducts);

    const flattenedProducts = R.toPairs(groupedProducts).flatMap((items) => items[1] ?? []) as T[];
    return flattenedProducts;
  }
}

export default OrderProductsSorterProduct;
